module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/logo_footer-33f90ec2eba61ad268dab054d2296d1a.svg";